const Constant = {
    perPage: 15,
}

export default Constant;